module.exports = __webpack_public_path__ + "static/media/logoCompanyVerticalWhite.0fcb6409.svg";